<template>
  <div class="top-left">
    <a-tabs style="width: 100%" :value="tabValue" @change="changeTab" size="small">
      <a-tab-pane key="1" :tab="$t('page_my_document')"> </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('page_resource_pool')"> </a-tab-pane>
    </a-tabs>
    <div class="top-left-box">
      <div class="top-left-box-tree">
        <a-tree
          showLine
          showIcon
          :defaultExpandAll="false"
          :treeData="treeData"
          :selectedKeys="selectedKeys"
          :loadedKeys="loadedKeys"
          :loadData="loadData"
          :expandedKeys="expandedKeys"
          @select="(keys, info) => onSelectTree(keys, info.node.dataRef)"
          @expand="expandKey"
        >
          <template slot="customTitle" slot-scope="item">
            <div class="custom-tree-item">
              <span>{{ item.title }}</span>

              <template v-if="item.expanded">
                <a-icon
                  slot="switcherIcon"
                  type="folder-open"
                  theme="filled"
                  style="color: #4a90e2; font-size: 16px; position: absolute; left: -25px; top: 4px; z-index: 10;"
                />
              </template>

              <template v-else>
                <a-icon
                  slot="switcherIcon"
                  type="folder"
                  theme="filled"
                  style="color: #4a90e2; font-size: 16px; position: absolute; left: -25px; top: 4px; z-index: 10;"
                />
              </template>
            </div>
          </template>
        </a-tree>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ManageDirectoryServiceProxy,
  FolderServiceProxy,
  ResourceServiceProxy
} from '@/service-proxies/app-v2/dnc.service-proxies'
const folderservice = new FolderServiceProxy()
const mdsp = new ManageDirectoryServiceProxy()
const rsp = new ResourceServiceProxy()

export default {
  data() {
    return {
      tabValue: '1',
      treeData: [],
      selectedInfo: {},
      pInfo: {},
      loadedKeys: [], // 懒加载树节点
      expandedKeys: [], // 展开树节点
      isFirst: true
    }
  },
  props: {
    selectedKeys: {
      // 选择树节点
      type: Array,
      default: () => []
    },
    back: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    selectedKeys: {
      handler() {
        if (this.selectedKeys && this.selectedKeys.length) {
          this.findInfo(this.treeData, this.selectedKeys[0])
        }
      },
      immediate: true,
      deep: true
    },
    back: {
      handler() {
        if (this.selectedInfo.parentId) {
          this.onSelectTree([this.selectedInfo.parentId])
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.getTree('0')
  },
  methods: {
    findInfo(treeData, id) {
      treeData.forEach((value) => {
        if (value.key === id) {
          this.selectedInfo = value
        } else {
          if (value.children && value.children.length) {
            this.findInfo(value.children, id)
          }
        }
      })
    },
    onSelectTree(selectedKeys) {
      if (!selectedKeys.length) {
        return
      }
      this.$emit('selectTree', selectedKeys)
    },
    expandKey(value) {
      this.expandedKeys = value
    },
    async getTree(value) {
      // 我的文档树目录
      this.expandedKeys = []
      this.$emit('selectTree', [])
      this.loadedKeys = []
      this.$emit('load', true)
      const res = await folderservice.lazyFolderList(value)
      this.treeData = [
        {
          title: this.$t('page_my_document'),
          key: '0',
          id: '0',
          scopedSlots: { title: 'customTitle' },
          children: []
        }
      ]
      if (res) {
        const childrens = this.addsCopedSlots(res, '0')
        this.treeData[0].children = childrens
      }
      this.expandedKeys = ['0']
      this.loadedKeys = ['0']
      this.onSelectTree(['0'])
      this.$emit('load', false)
    },
    async loadTreeData() {
      this.isFirst = true
      this.expandedKeys = []
      this.$emit('selectTree', [])
      this.loadedKeys = []
      this.$emit('load', true)
      const res = await mdsp.treeList(0)
      if (res && res.length) {
        const tree = []
        res.forEach((item) => {
          const value = this.nodeTree(item, '')
          tree.push(value)
        })
        this.treeData = tree
      }
      this.$emit('load', false)
    },
    nodeTree(element, pid) {
      const node = {
        title: element.title,
        key: element.id,
        scopedSlots: { title: 'customTitle' },
        isLeaf: false,
        selectable: false,
        parentId: pid,
        children: []
      }
      if (element.children && element.children.length) {
        const children = []
        element.children.forEach((res) => {
          children.push(this.nodeTree(res, element.id))
        })
        node.children = children
      }
      return node
    },
    addsCopedSlots(value, pid) {
      value.forEach((element) => {
        element.title = element.name
        element.key = element.id
        element.scopedSlots = { title: 'customTitle' }
        element.isLeaf = false
        element.parentId = pid
      })
      return value
    },
    loadData(treeNode) {
      return new Promise((resolve) => {
        const data = treeNode.dataRef ? treeNode.dataRef : treeNode
        this.pushKey(this.treeData, data.key)
        if (this.tabValue === '1') {
          folderservice.lazyFolderList(data.key).then((res) => {
            if (res && res.length > 0) {
              data.children = this.addsCopedSlots(res, data.key)
              data.isLeaf = false
              this.treeData = [...this.treeData]
              resolve()
            } else {
              data.children = []
              data.isLeaf = false
              this.treeData = [...this.treeData]
              resolve()
            }
          })
        } else {
          rsp.list(data.key, {}).then((item) => {
            if (item && item.length) {
              let chil = []
              chil = item.map((element) => {
                const arr = {
                  title: element.displayName,
                  key: element.id,
                  scopedSlots: { title: 'fileTitle' },
                  isLeaf: true,
                  parentId: data.key
                }
                return arr
              })
              data.children = chil.concat(data.children)
              data.isLeaf = false
              this.treeData = [...this.treeData]
              resolve()
            } else {
              data.isLeaf = false
              this.treeData = [...this.treeData]
              resolve()
            }
          })
        }
      })
    },
    pushKey(data, key) {
      if (data && data.length > 0) {
        data.forEach((item) => {
          if (item.key === key) {
            if (this.expandedKeys.indexOf(item.key) === -1) {
              this.expandedKeys.push(item.key)
            }
            if (this.loadedKeys.indexOf(item.key) === -1) {
              this.loadedKeys.push(item.key)
            }
            if (item.parentId) {
              this.pushKey(this.treeData, item.parentId)
            }
          } else {
            if (item.children && item.children.length > 0) {
              this.pushKey(item.children, key)
            }
          }
        })
      }
    },
    changeTab(value) {
      this.tabValue = value
      if (value === '1') {
        this.getTree('0')
      } else {
        this.loadTreeData(0)
      }
      this.$emit('changeTab', value)
    }
  }
}
</script>

<style lang="less" scoped>
.top-left {
  height: 100%;
  &-box {
    padding: 8px;
    height: calc(100% - 38px);
    &-tree {
      border: 1px solid #d8d8d8;
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }

  /deep/ .ant-tabs {
    overflow: inherit;
  }

  /deep/ .ant-tabs-bar {
    bottom: -1px;
    border-bottom: 1px solid #d9d9d9;
    margin: 0;
  }

  /deep/ .ant-tabs .ant-tabs-small-bar .ant-tabs-tab {
    padding: 9px 16px;
    margin: 0;
    width: 50%;
    text-align: center;
  }

  /deep/ .ant-tabs-nav {
    width: 100%;
  }

  /deep/ .ant-tabs-nav .ant-tabs-tab:first-child {
    border-right: 1px solid #d9d9d9;
  }

  /deep/ .ant-tabs-nav .ant-tabs-tab-active {
    background-color: #fff;
  }

  /deep/ .ant-tabs-ink-bar {
    top: -1px !important;
    z-index: 99;
    background-color: #4a90e2;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
    bottom: auto;
    height: 4px;
  }
  /deep/ .ant-tree li span.ant-tree-switcher.ant-tree-switcher-noop {
    visibility: hidden;
  }

  /deep/ .ant-tree-treenode-selected > span .right-drop-down {
    display: block !important;
  }

  /deep/ .ant-tree.ant-tree-show-line li span.ant-tree-switcher {
    background-color: transparent;
  }

  /deep/ .ant-tree li span.ant-tree-switcher.ant-tree-switcher-noop {
    opacity: 0 !important;
  }

  /deep/ .ant-tree li .ant-tree-node-content-wrapper {
    width: calc(100% - 24px);
    /*background-color: #d0edff;*/
  }

  /deep/ .ant-tree-title {
    position: relative;
  }

  /deep/ .ant-tree-switcher {
    color: rgba(0, 0, 0, 0) !important;
    position: relative;
    z-index: 99;
  }

  /deep/ .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
    background-color: rgb(255, 241, 184);
  }

  // /deep/ .ant-tree.ant-tree-show-line li:not(:last-child):before {
  //   border-color: transparent;
  // }
}
</style>
